import React, { useState, useEffect } from "react";
import {
  Card,
  CardMedia,
  CardActionArea,
  IconButton,
  Paper,
  Typography,
  Button,
} from "@material-ui/core";
import { useStyles } from "./classes";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import { useDispatch } from "react-redux";
import { hideHeader, showHeader } from "../../redux/actions/header";
//testy change
import FavoriteIcon from "@material-ui/icons/Favorite";
import * as api from "../../api/index.js";

const MenuCard = ({ trending, ids, gets }) => {

  const classes = useStyles();
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("profile"));
  let dispatch = useDispatch();

  const addMenu = async (ids) => {
    setIsOpen(true);
    if (ids) {
      var current = new Date();
      await api.addMenuClick({
        code: "VIEW",
        eventType: "click",
        eventName: "menuClick",
        view: current.toLocaleDateString(),
        resName: trending.restaurantId.name,
        menuName: trending.name,
        restaurantId: trending.restaurantId._id,
      });
    }
  };

  const images = trending.images;
  useEffect(() => {
    if (!isOpen) {
      dispatch(showHeader());
    }
  }, [isOpen, dispatch]);

  const favoriteRemove = async (id) => {
    try {
        await api.removeFavd({
        type: "menu",
        id: id,
      });

      await gets(ids);

    } catch (error) {
      console.log(error);
    }
  };

  const favoriteAdd = async (id) => {
    try {
      await api.addToFavd({
        type: "menu",
        id: id,
      });
      await gets(ids);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Card className={classes.root}>
      <CardActionArea>


        <Paper className={classes.itemCard}>
          <CardMedia
            className={classes.media}
            image={trending.images[0]}
            title="Dish Image"
          />
        </Paper>
        <div className={classes.numberWrapMain}>
          <div className={classes.numberWrap}>
            {" "}
            <Typography className={classes.numberText}>
              1/{trending.images.length}
            </Typography>
          </div>
          <div
            style={{
              width: 50,
              height: 25,
              Color: "rgba(255,255,255, 0.7)",
              zIndex: '1',
              position: 'absolute',
              right: '25px',
              bottom: '0',
            }}
          >
            {user && (
              <IconButton
                aria-label="add to favorites"
                onClick={() =>
                  trending.isFavorite
                    ? favoriteRemove(trending._id)
                    : favoriteAdd(trending._id)
                }
              >
                {trending.isFavorite ? (
                  <FavoriteIcon style={{ color: "red" }} fontSize="small" />
                ) : (
                  <FavoriteBorderIcon
                    style={{ color: "#fff" }}
                    fontSize="small"
                  />
                )}
              </IconButton>
            )}
          </div>
        </div>

        <div className={classes.viewWrap}>
          <Button
            variant="contained"
            style={{
              backgroundColor: "#e45826",
              color: "#fffffff",
              width: 130,
              height: 30,
            }}
            className={classes.view}
            onClick={() => addMenu(ids)}
          >
            View
          </Button>
          {isOpen && (
            <Lightbox
              mainSrc={images[photoIndex]}
              nextSrc={images[(photoIndex + 1) % images.length]}
              prevSrc={images[(photoIndex + images.length - 1) % images.length]}
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + images.length - 1) % images.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % images.length)
              }
              onAfterOpen={() => dispatch(hideHeader())}
            />
          )}
        </div>     <div className={classes.overlay}>
          <Typography
            style={{ alignSelf: "center" }}
            className={classes.mainText}
          >
            {trending.name}
          </Typography>
        </div>
        {/* <img
                    src={trending.restaurantId.logo}
                    alt='restaurant-logo'
                    className={styles.Img}
                    /> */}

        {/* <Chip
                    className={styles.Chip}
                    label={trending.restaurantId.name}
                    style={{ borderRadius: '0px 10px 10px 0px' }}
                    /> */}
      </CardActionArea>
      {/* <Chip className={classes.chip} label={trending.restaurantId.name} /> */}
    </Card>
  );
};

export default MenuCard;
